export function createOnClickFromExternalUrl(externalUrl: string): React.MouseEventHandler<HTMLElement> {
  return (e) => {
    e.preventDefault();
    e.stopPropagation();
    return window.open(externalUrl, '_blank');
  };
}